// components/CurrentInvestmentForm.js
import React, { useEffect, useState } from 'react';
import {
  CardContent, 
  Typography, 
  TextField,
  InputAdornment,
  Box,
  Button
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { useAppContext } from '../context/AppContext';
import { financialService } from '../utils/api';

function Others() {

  const { state, actions } = useAppContext();
  const [value,setValues] = useState({
    gold: state.gold || '',
    otherInvestments: state.otherInvestments || '',
    realEstate: state.realEstate || '',
  });

  useEffect(() => {
    setValues({
      gold: state.gold || '',
      otherInvestments: state.otherInvestments || '',
      realEstate: state.realEstate || ''
    })
  }, [state.gold, state.realEstate, state.otherInvestments])
  
  const handleChange = (field) => (e) => {
    const raw = e.target.value.replace(/,/g, '');
    const value = raw === '' ? '' : parseInt(raw, 10) || 0;
  
    setValues(prev => ({ ...prev, [field]: value }));
    actions.updateFormData(field, value === '' ? 0 : value);
  };
  

  const formatNumber = (num) => {
    return num === '' ? '' : new Intl.NumberFormat('en-IN').format(num);
  };

  const handleSumbit = async () => {
    try{
      console.log(state.phoneNumber)
      await financialService.submitCashFlow(state.phoneNumber,
        {
          "salary": state.salary,
          "spouse_salary": state.spouseSalary,
          "other_income": state.otherIncome,
          "monthly_expense": state.monthlyExpense,
          "one_time_yearly": state.oneTimeYearly,
          "annual_investments": state.annualInvestments,
          "sip": state.sip
        }
      )

      await financialService.submitInvestment(state.phoneNumber,
        {
          "bank_balance": state.bankBalance,
          "fixed_deposit": state.fixedDeposit,
          "retirement_fund": state.retirementFund,
          "bonds": state.bonds,
          "debt_mf": state.debtMF,
          "equity_mf": state.equityMF,
          "hybrid_mf": state.hybridMF,
          "invits": state.invits,
          "stocks": state.stocks,
          "pms": state.pms,
          "unlisted": state.unlisted,
          "global_equity": state.globalEquity,
          "global_bonds": state.globalBonds,
          "global_mf": state.globalMF,
          "real_estate": state.realEstate,
          "gold": state.gold,
          "other_investments": state.otherInvestments
        }
      )

      await financialService.emailRecord(state.phoneNumber
        // {
        //   "salary": state.salary,
        //   "spouse_salary": state.spouseSalary,
        //   "other_income": state.otherIncome,
        //   "monthly_expense": state.monthlyExpense,
        //   "one_time_yearly": state.oneTimeYearly,
        //   "annual_investments": state.annualInvestments,
        //   "sip": state.sip,
        //   "bank_balance": state.bankBalance,
        //   "fixed_deposit": state.fixedDeposit,
        //   "retirement_fund": state.retirementFund,
        //   "bonds": state.bonds,
        //   "debt_mf": state.debtMF,
        //   "equity_mf": state.equityMF,
        //   "hybrid_mf": state.hybridMF,
        //   "invits": state.invits,
        //   "stocks": state.stocks,
        //   "pms": state.pms,
        //   "unlisted": state.unlisted,
        //   "global_equity": state.globalEquity,
        //   "global_bonds": state.globalBonds,
        //   "global_mf": state.globalMF,
        //   "real_estate": state.realEstate,
        //   "gold": state.gold,
        //   "other_investments": state.otherInvestments
        // }

      )
    }
    catch(err){
      console.log(err)
    }
    finally{

    }
  }

  return (
    <Box>
      <CardContent>
      <Box sx={{ mb: 2 }}>
      <Typography variant='h6' sx={{mb:2, color: 'primary.main'}}>
            Real Estate & Other Investments
          </Typography>
        {/* <Typography variant="body1" component="h2" gutterBottom>
         InvITs/REITs
        </Typography>

          <TextField
            // label="InvITs/REITs"
            placeholder='sum of InvITs and REITs'
            value={value.invits ? formatNumber(value.invits) : ''}
            onChange={handleChange('invits')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          /> */}
        </Box>
      <Box sx={{ my: 2}}>
      <Typography variant="body1" component="h2" gutterBottom>
        Real Estate (Excluding primary residence)
        </Typography>
        
          <TextField
            // label="Real Estate"
            placeholder='total value of real estate'
            value={formatNumber(value.realEstate)}
            onChange={handleChange('realEstate')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>
        
        <Box sx={{ mt: 2 }}>
            
        <Typography variant="body1" component="h2" gutterBottom>
         Gold (Excluding  jwellery)
        </Typography>
      
          <TextField
            // label="Gold"
            placeholder='total value of gold'
            value={formatNumber(value.gold)}
            onChange={handleChange('gold')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>
        <Box sx={{ mt: 2 }}>
            
        <Typography variant="body1" component="h2" gutterBottom>
         All Others Investments
        </Typography>
      
          <TextField
            // label="Gold"
            placeholder='total value'
            value={formatNumber(value.otherInvestments)}
            onChange={handleChange('otherInvestments')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            justifyContent: 'center', 
            py: 4 
          }}>
        {/* <Button
                variant="contained"
                color="success"
                size="large"
                endIcon={<ArrowForwardIcon />}
                onClick={() => {
                  handleSumbit()
                  actions.nextStepAsset()
                  // actions.setStepperMode('assetAllocation');
                  // actions.setActiveStepAsset(0); // start asset steps
                }}
                sx={{
                  borderRadius: 1,
                  py: 1.5,
                  textTransform: 'none',
                  fontWeight: 'bold'
                }}
              >
                Explore Insights
            </Button> */}
            </Box>
      </CardContent>
</Box>
  );

}

export default Others;
